import { render, staticRenderFns } from "./OkrListTotalizer.vue?vue&type=template&id=35e69084"
import script from "./OkrListTotalizer.vue?vue&type=script&lang=js"
export * from "./OkrListTotalizer.vue?vue&type=script&lang=js"
import style0 from "./OkrListTotalizer.vue?vue&type=style&index=0&id=35e69084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports